import React, { useMemo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { QrReader } from 'react-qr-reader';
import GoBackBtn from '../components/goBackBtn';
import CouponList from '../components/couponList';
import ErrorModal from '../components/errorModal';
import Loading from '../components/loading';
import styles from '../styles/Scanner.module.scss';
import API from '../services/api';
import store from 'store-js';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useCookieState } from 'ahooks';

const placeholderStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    top: '45%',
    color: '#888888'
};

const nextBtnDivStyle = {
    marginRight: '20px',
    marginLeft: '20px',
    zIndex: '999',
    position: 'sticky',
    bottom: '0px',
    background: '#fff',
    height: '100%'
};

export default function Scanner({ config }) {
    const pageSetting = config.scannerPage_setting;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [token, setToken] = useCookieState('access_token', { secure: true, sameSite: 'strict' });
    const name = 'scanner';
    const storeId = store.get('store_id');
    const [loading, setLoading] = useState(true);
    const [qrcode, setQrcode] = useState(null);

    // For checking if all vouchers in QR code(multi vouchers) are scanned
    const [existCodes, setExistCodes] = useState(0);
    const [codeLength, setCodeLength] = useState(0);
    const [handleNext, setHandleNext] = useState(false);

    const [coupons, setCoupons] = useState([]);

    const [errMsg, setErrMsg] = useState(null);
    const [errCounter, setErrCounter] = useState(0);

    // const [showErrModal, setShowErrModal] = useState(false);
    const [errModalMsg, setErrModalMsg] = useState(null);
    const [consoleMsg, setConsoleMsg] = useState(null);
    const [minAmountModalMsg, setMinAmountModalMsg] = useState(null);

    const [clickedDel, setClickedDel] = useState(false);
    const [isFetchingData, setIsFetchingData] = useState(false);

    const [savedQRcode, setSavedQRcode] = useState([]);
    const [user, setUser] = useState(null);

    // const [countDown, setCountDown] = useState(store.get("codeCountDown") || 20);
    // const [timeoutID, setTimeoutID] = useState(store.get("timeoutId" || null));

    const couponHasMinAmount = useMemo(() => {
        // cause now langham only handle one coupon a time, so coupons length must = 0
        if (coupons?.length > 0) {
            return parseInt(coupons[0].minSpendingAmount) > 0;
        }
        return false;
    }, [coupons]);

    useEffect(() => {
        if (!token) navigate('/');

        setLoading(false);

        if (store.get('coupons')?.length > 0) {
            setCoupons(store.get('coupons'));
        }
        if (store.get('scannedQRcode')?.length > 0) {
            setSavedQRcode(store.get('scannedQRcode'));
        }
        if (store.get('owner_customer_id')) setUser(store.get('owner_customer_id'));

        // let arr = [];
        // for (let i = 0; i < 1; i++) {
        //   let couponObj = {
        //     amt: 100,
        //     code: "ONETIME::bZUrx4ahwZGGw3T9CxNwP8mWYDwUWFfUCREJR7vSus2P36JKLVSfLePfatpMWqG4nD9a99yzYKdGCQRp7PYRe2Qn4c4bCFR2LVxYvjLJyPjQudCcEAGsxQvaK4F4zu7J",
        //     customer_id: "undefined",
        //     id: "19",
        //     name: "agnès b. (testing)",
        //     oneTimeExpireTime: "1660554778",
        //     qty: "1",
        //   };
        //   arr.push(couponObj);
        // }
        // setCoupons(arr);
    }, []);

    useEffect(() => {
        if (qrcode && coupons.length === 0) {
            if (!isFetchingData && token !== null && !errModalMsg) {
                examineQRcode(qrcode);
            }
        }
    }, [qrcode, coupons]);

    useEffect(() => {
        if (user) store.set('owner_customer_id', user);
    }, [user]);

    useEffect(() => {
        if (coupons) {
            if (coupons !== store.get('coupons')) store.set('coupons', coupons);
            setQrcode();
            setIsFetchingData(false);
        }
    }, [coupons]);

    useEffect(() => {
        if (savedQRcode && savedQRcode !== store.get('scannedQRcode')) store.set('scannedQRcode', savedQRcode);
        // Remove saved user if all coupons are deleted
        if (clickedDel && savedQRcode.length === 0) store.remove('owner_customer_id');
        // Reset clickedDel
        setClickedDel(false);
        setQrcode();
        setIsFetchingData(false);
    }, [savedQRcode]);

    useEffect(() => {
        if (existCodes) {
            if (codeLength == existCodes) return setErrMsg(t(`${pageSetting.scannerErrs.scanned}`));
        }
    }, [existCodes]);

    // Reset error message
    useEffect(() => {
        if (errMsg) {
            setTimeout(() => {
                setErrMsg(null);
                setQrcode();
                setIsFetchingData(false);
            }, 5000);
        }
    }, [errMsg]);

    useEffect(() => {
        console.log('err: ', errCounter);
        // Remind error count reached 8 times
        if (errCounter === 8) {
            setErrModalMsg(t(`${pageSetting.scannerErrs.wrongScan_msg}`));
        }
        // Logout a/c when error count reached 10
        if (errCounter === 10) {
            setErrModalMsg(t(`${pageSetting.scannerErrs.wrongScanMax_msg}`));
        }
        // setTimeout(() => {
        //   setIsFetchingData(false);
        //   setErrMsg(null);
        // }, 2500);
    }, [errCounter]);

    const handleCloseModal = () => {
        // Logout a/c when error count reached 10
        if (errModalMsg === t(`${pageSetting.scannerErrs.wrongScanMax_msg}`)) {
            store.clearAll();
            navigate('/');
        } else {
            setErrModalMsg();
            setConsoleMsg();
            setQrcode();
            setIsFetchingData(false);
        }
    };

    const handleMinAmountCloseModal = () => {
        setMinAmountModalMsg(null);
        handleNextPage(false);
    };

    const handleDelete = (data) => {
        let delCode = data.id;
        setClickedDel(true);

        let newData = coupons.filter((item) => {
            return item !== data;
        });
        setCoupons(newData);

        let newScannedQR = savedQRcode.filter((item) => {
            return item.id !== delCode;
        });
        setSavedQRcode(newScannedQR);
        setQrcode();
        setIsFetchingData(false);
    };

    const handleNextPage = (checkMinAmount) => {
        if (checkMinAmount && couponHasMinAmount) {
            setMinAmountModalMsg(t('scannerPage_coupons_has_min_amount'));
            return;
        }
        setLoading(true);
        // Check if codes are used within time period after generation
        let expireTime = coupons[0].oneTimeExpireTime;
        var epoch = moment().unix(); // do I need to do .local()?
        if (expireTime) {
            let expired = parseInt(expireTime) < epoch;
            if (expired) {
                setLoading(false);
                return setErrModalMsg(t('scannerErr_notEnoughCodes'));
            } else navigate('/redeem');
        } else navigate('/redeem');
    };

    /* Dummy Code Testing */
    // const checkOwner = (id) => {
    //   // Check if code belongs to same owner
    //   if (!user) {
    //     setUser(id);
    //     store.set("owner_customer_id", id);
    //   } else {
    //     // console.log({ user });
    //     if (user && user !== id) {
    //       setShowErrModal(true);
    //       setErrModalMsg("diff_user_coupons");
    //       return setIsFetchingData(false);
    //     }
    //   }
    // };
    // const checkOwnerVouchers = (data, codes) => {
    //   // console.log(codes);
    //   let dummyData;
    //   let owner;
    //   let newArr = [];
    //   let newSavedArr = savedQRcode;
    //   let savedCodes = false;

    //   dummyData = data;

    //   dummyData.map((item) => {
    //     // Screen put expired & mismatch vouchers
    //     if (!item.hasOwnProperty("id")) return;

    //     let voucherArr = item.vouchers.map((str) => {
    //       return str.split(", ");
    //     });
    //     // console.log(voucherArr);

    //     let formattedCodes = Array.isArray(codes) ? codes : codes.split(", ");
    //     // console.log({ formattedCodes });

    //     voucherArr.map((arr) => {
    //       arr.forEach((val) => {
    //         if (formattedCodes.includes(val)) {
    //           owner = item.id;
    //           console.log(item.id);
    //           if (user && user !== item.id) {
    //             setShowErrModal(true);
    //             setErrModalMsg("diff_user_coupons");
    //             return setIsFetchingData(false);
    //           }

    //           let couponObj = {
    //             name: `voucher[$100]`,
    //             amt: 100,
    //             codes: val,
    //             customer_id: item.id,
    //           };

    //           checkOwner(item.id);

    //           newArr.push(couponObj);
    //           if (!savedCodes) {
    //             newSavedArr.push(codes);
    //             savedCodes = true;
    //           }
    //         }
    //       });
    //     });
    //   });
    //   if (!owner) {
    //     setErrMsg(`${t("scannerErr_invalid")}`);
    //     let count = errCounter;
    //     setErrCounter(count + 1);
    //     setIsFetchingData(false);
    //     return;
    //   }
    //   if (newArr.length === 0) owner = null;
    //   // console.log({ coupons });
    //   // console.log({ newArr });
    //   if (newArr.length === 0) {
    //     setShowErrModal(true);
    //     let count = errCounter;
    //     setErrCounter(count + 1);
    //     return setErrModalMsg("diff_user_coupons");
    //   }

    //   setCoupons((arr) => (coupons.length > 0 ? arr.concat(newArr) : newArr));
    //   savedQRcode.length < 1
    //     ? setSavedQRcode(newSavedArr)
    //     : setSavedQRcode([newSavedArr.flat().join(", ")]);
    // };
    /////////////////////////////////////////////

    const createRecordObj = (items, codeType, oneTimeExpireTime) => {
        /* Check if code is already scanned */
        let exists = savedQRcode.find((saved) => saved.code === items.code);
        if (exists) {
            if (codeType === 'single') {
                return setErrMsg(t(`${pageSetting.scannerErrs.scanned}`));
            } else {
                setExistCodes((existCodes) => existCodes + 1);
                console.log('Contains scanned voucher');
                return;
            }
        }
        /* Check if voucher can be used in this merchant */
        if (
            items.loyalty_product.store_ids.length > 0 &&
            !items.loyalty_product.store_ids.split(',').includes(storeId)
        ) {
            if (codeType === 'single') {
                return setErrMsg(t(`${pageSetting.scannerErrs.mismatch}`));
            } else return;
        }
        /* Check if voucher is used */
        if (items.used_time) {
            if (codeType === 'single') {
                return setErrMsg(t(`${pageSetting.scannerErrs.used}`));
            } else {
                console.log('Contains used voucher');
                setQrcode();
                setIsFetchingData(false);
                return;
            }
        }
        /* Check if voucher is expired */
        // if (items.use_expiry_time && items.use_expiry_time < moment(new Date()).unix()) {
        //     if (codeType === 'single') {
        //         return setErrMsg(t(`${pageSetting.scannerErrs.expired}`));
        //     } else {
        //         console.log('Contains expired voucher');
        //         setQrcode();
        //         setIsFetchingData(false);
        //         return;
        //     }
        // }
        /* Cannot scan more than 1 code */
        if (coupons.length > 0) return setErrModalMsg(t('scannerErr_moreThanOne'));

        let couponObj = {
            id: items.loyalty_product.id,
            name: items.loyalty_product.name,
            amt: Number(items.loyalty_product.value_amount ? items.loyalty_product.value_amount : 100),
            code: items.code,
            qty: items.quantity,
            customer_id: items.owner_customer_id,
            oneTimeExpireTime: oneTimeExpireTime || null,
            minSpendingAmount: items.loyalty_product.min_spending_amount
            // oneTimeRef: items.loyalty_product_voucher_onetime_id,
        };

        setSavedQRcode((saved) => [...saved, couponObj]);
        setCoupons((arr) => [...arr, couponObj]);
    };

    const examineQRcode = (code) => {
        const api = new API(token);
        setIsFetchingData(true);
        if (code.includes('ONETIME')) {
            api.queryOneTimeCode(code)
                .then((data) => {
                    console.log('data.response.code', data.response.code);
                    if (data && data.response.code === '200') {
                        let dataObj = data.payload;
                        const maxUseQty = parseInt(dataObj?.loyalty_product.max_use_qty);
                        if (maxUseQty > 0 && parseInt(dataObj?.quantity) > maxUseQty) {
                            setErrModalMsg(t('scannerErr_exceededMaxUseQty', { max_use_qty: maxUseQty }));
                            return;
                        }
                        if (data.payload.length < 1) {
                            setErrModalMsg(`${t(pageSetting.scannerErrs.invalid)}`);
                            return getScanErrCount();
                        }
                        if (dataObj?.used_time) {
                            return setErrMsg(t(`${pageSetting.scannerErrs.used}`));
                        } else if (dataObj.status !== '1') {
                            if (dataObj.status === '2') setErrMsg(t(`${pageSetting.scannerErrs.used}`));
                            if (dataObj.status === '3') setErrMsg(t(`${pageSetting.scannerErrs.voided}`));
                            return;
                        } else {
                            // createRecordObj(dataObj, "single", null);
                            createRecordObj(dataObj, 'single', data.payload?.use_expiry_time);
                            //   return getVoucherInfo(api, code, "onetime");
                        }
                    } else if (data && data.response.code === '401') {
                        if (errCounter < 9) {
                            setErrModalMsg(`${t(config.scannerErr_setting.errMsg.invalidToken)}`);
                        } else setErrModalMsg(`${t(`${pageSetting.scannerErrs.wrongScanMax_msg}`)}`);
                        getScanErrCount();
                    } else if (data && data.payload.error_code === '4200') {
                        setErrModalMsg(`${t(pageSetting.scannerErrs.invalid)}`);
                        getScanErrCount();
                    } else if (data && data.payload.error_code === '4520') {
                        setErrMsg(`${t(pageSetting.scannerErrs.expired)}`);
                        getScanErrCount();
                    } else if (data && data.payload.error_code === '4521') {
                        setErrMsg(`${t(pageSetting.scannerErrs.mismatch)}`);
                        getScanErrCount();
                    } else {
                        setErrMsg(data.payload?.error_message);
                        getScanErrCount();
                        // setErrCounter(errCounter + 1);
                    }
                })
                .catch((err) => {
                    setConsoleMsg(t('errMsg_networkErr'));
                    setQrcode();
                    setIsFetchingData(false);
                    console.log(err);
                });
        } else getVoucherInfo(api, code);
    };

    const getVoucherInfo = (api, codes, type) => {
        api.queryVoucher(codes)
            .then((data) => {
                if (data && data.response.code === '200') {
                    // console.log(Object.values(data.payload)[0]);
                    // Save owner_customer_id if doesn't exists &
                    // Check if coupons belong to same user using owner_customer_id
                    let payloadData = Object.values(data.payload);
                    if (!store.get('owner_customer_id')) {
                        if (payloadData[0].owner_customer_id === null) {
                            // setShowErrModal(true);
                            setErrModalMsg('invalid_phone');
                            return;
                        } else store.set('owner_customer_id', payloadData[0].owner_customer_id);
                    }
                    if (store.get('owner_customer_id') !== payloadData[0].owner_customer_id) {
                        setErrModalMsg(t('errMsg_diff_user_coupons'));
                        return;
                    }

                    if (payloadData.length > 1) {
                        console.log(payloadData.length);
                        setCodeLength(payloadData.length);
                        payloadData.map((item) => {
                            createRecordObj(item, 'multi');
                        });
                    } else {
                        createRecordObj(payloadData[0], 'single');
                    }

                    // if (
                    //     parseInt(payloadData && payloadData[0] && payloadData[0].loyalty_product.min_spending_amount) >
                    //     0
                    // ) {
                    //     setMinAmountModalMsg('此電子劵設有最低消費要求');
                    // }

                    setQrcode();
                } else if (data && data.response.code === '401') {
                    if (errCounter < 9) {
                        setErrModalMsg(`${t(config.scannerErr_setting.errMsg.invalidToken)}`);
                    } else setErrModalMsg(`${t(`${pageSetting.scannerErrs.wrongScanMax_msg}`)}`);
                } else {
                    switch (data.payload.error_code) {
                        case '4513':
                            setErrModalMsg(t('scannerErr_notEnoughCodes') + ' (P3)');
                            break;
                        case '4403':
                            setErrModalMsg(t('errMsg_wrong_coupon'));
                            break;
                        case '4200':
                            setErrModalMsg(`${t(pageSetting.scannerErrs.invalid)}`);
                            break;
                        default:
                            setErrMsg(data.payload?.error_message);
                            break;
                    }
                    getScanErrCount();
                    // setErrCounter(errCounter + 1);
                }
            })
            .catch((err) => {
                // setShowErrModal(true);
                setConsoleMsg(t('errMsg_networkErr'));
                console.log(err);
            })
            .finally(() => {
                setQrcode();
                setIsFetchingData(false);
                setConsoleMsg(null);
            });
    };

    const handleScan = (code) => {
        if (errMsg) return;

        if (!qrcode) {
            setQrcode(code);
            setExistCodes(0);
            setCodeLength(0);
        } else return;
    };

    const getScanErrCount = () => {
        const api = new API(token);
        api.getScanErrCount()
            .then((res) => {
                console.log(res);
                if (res) {
                    setErrCounter(res.payload?.scan_error_times);
                }
            })
            .catch((err) => console.log('Error in scan-error call:', err));
    };

    const DataDivContent = () => {
        return coupons.length === 0 ? (
            <p style={placeholderStyle}>{t('scannerPage_text_onInit')}</p>
        ) : (
            <CouponList
                name={name}
                data={coupons}
                handleDelete={handleDelete}
                t={t}
                config={config}
                pageSetting={pageSetting}
            />
        );
    };

    return (
        <>
            <div className="content noselect">
                <div className="backBtnDiv">
                    <GoBackBtn color="white" />
                </div>

                <div className={styles.scannerDiv}>
                    <div className={styles.borderDiv}>
                        <QrReader
                            constraints={{ facingMode: 'environment' }}
                            scanDelay={500}
                            onResult={(result, error) => {
                                // console.log("onResult res: ", result);
                                // console.log("onResult err: ", error);
                                if (!!result) {
                                    handleScan(result?.text);
                                }

                                if (!!error) {
                                    // console.info(error);
                                }
                            }}
                            // containerStyle={{ width: "100%" }}
                            videoStyle={
                                window.screen.width < 380
                                    ? { width: '250px', height: '250px' }
                                    : window.screen.width < 641
                                    ? { width: '320px', height: '320px' }
                                    : { width: '320px', height: '320px' }
                            }
                            containerStyle={{ width: '100%' }}
                        />
                        <div style={{ height: 'max-content' }}>
                            <button className={styles.scanErr} disabled style={{ display: errMsg ? 'block' : 'none' }}>
                                {errMsg}
                            </button>
                        </div>
                    </div>
                </div>

                <div className={styles.dataDiv}>
                    <DataDivContent />
                </div>

                {loading && (
                    <div className="loadingBg">
                        <Loading
                            className="loadingBtn"
                            color={config.theme.color}
                            style={{
                                width: '50px',
                                height: '50px'
                            }}
                        />
                    </div>
                )}
                <ErrorModal
                    openModal={errModalMsg || consoleMsg ? true : false}
                    errorMsg={errModalMsg}
                    consoleMsg={consoleMsg}
                    handleCloseModal={handleCloseModal}
                    t={t}
                    config={config}
                />
                <ErrorModal
                    openModal={minAmountModalMsg || consoleMsg ? true : false}
                    errorMsg={minAmountModalMsg}
                    consoleMsg={consoleMsg}
                    handleCloseModal={handleMinAmountCloseModal}
                    t={t}
                    config={config}
                />
                {loading && <Loading />}
            </div>
            {coupons?.length > 0 && (
                <div style={nextBtnDivStyle}>
                    <button
                        type="button"
                        disabled={loading}
                        className="colorBtn fetch"
                        onClick={() => handleNextPage(true)}
                    >
                        {t('scannerPage_nextBtn_label')}
                    </button>
                </div>
            )}
        </>
    );
}
